import { render, staticRenderFns } from "./LessonSkeletonLoader.vue?vue&type=template&id=fddde404&scoped=true&"
import script from "./LessonSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./LessonSkeletonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddde404",
  null
  
)

export default component.exports